import React, { useMemo, useState } from 'react';
import { Form, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import request from '../../../../../../../../utils/request';
import Modal from '../../../../../../../CustomizedAntDesign/Modal/Modal';
import Input from '../../../../../../../CustomizedAntDesign/Input/Input';
import Button from '../../../../../../../CustomizedAntDesign/Button';

const LaravoModalLoader = () => {
  return (
    <div className="cb-integrations-modal__loader">
      <LoadingOutlined />
      <span>Connecting...</span>
    </div>
  );
};

const IntegrationsLaravoModal = ({ visible, setVisible, installed, onSaved }) => {
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState('');

  const [form] = Form.useForm();

  const apiKey = Form.useWatch('api_key', form);

  const apiKeyPlaceholder = useMemo(() => (requestError ? 'Invalid API Key' : 'API Key'), [requestError]);

  const handleInstall = async () => {
    setRequestError('');
    setLoading(true);

    try {
      const { data } = await request.post('/integrations/laravo', { api_key: apiKey });

      const successMsg = installed
        ? 'Laravo API key updated'
        : 'Laravo installed successfully. Catalogs may take up to 24 hours to appear.';

      message.success(successMsg);

      onSaved(data);
      setVisible(false);
    } catch (error) {
      // The API tells invalid keys and a Laravo outage apart — passing that through
      // keeps merchants from re-typing a key that was fine all along.
      setRequestError(error?.response?.data?.message || 'Check your information and try again');

      form.setFieldsValue({ api_key: '' });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setRequestError('');
    setVisible(false);
  };

  return (
    <Modal open={visible} footer={null} closable={false} width={348} destroyOnClose className="cb-integrations-modal">
      {loading && <LaravoModalLoader />}

      <h2 className="cb-integrations-modal__title">Laravo API Key</h2>

      <h3 className="cb-integrations-modal__subtitle">
        Please enter the API key
        <br /> from your Laravo account
      </h3>

      <Form form={form} autoComplete="off" className={requestError ? 'cb-integrations-modal__input-error' : ''}>
        <Form.Item name="api_key">
          <Input prefix={<FontAwesomeIcon icon="far fa-key" />} placeholder={apiKeyPlaceholder} />
        </Form.Item>

        <span className="cb-integrations-modal__error" data-testid="integrations__laravo-modal--error">
          {requestError}
        </span>

        <Form.Item className="cb-integrations-details__form-footer">
          <Button disabled={loading} onClick={handleCancel} block>
            Cancel
          </Button>

          <Button type="primary" disabled={loading || !apiKey} onClick={handleInstall} block>
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default IntegrationsLaravoModal;
